<div class="campanhas-page campanha-form-page">
  <header class="campanha-form-header">
    <div class="campanha-form-title-block">
      <app-back-button routerLink="/campanhas" data-testid="voltar-campanhas" />
      <h1 class="page-main-title" data-testid="campanha-form-title">{{ pageTitle() }}</h1>
    </div>

  </header>

  <form [formGroup]="form" class="campanha-form" data-testid="campanha-form">
    <section
      class="campanha-form-section"
      aria-labelledby="campanha-form-section-1-title"
      data-testid="campanha-form-section-1"
    >
      <h2 id="campanha-form-section-1-title" class="campanha-form-section-title">
        1. Dados gerais
      </h2>

      <div class="campanha-form-fields row g-3">
        <div class="col-12 col-lg-6">
          <label class="campanha-form-label" for="campanha-form-nome">
            Nome da campanha
            <span class="campanha-form-required" aria-hidden="true">*</span>
          </label>
          <input
            id="campanha-form-nome"
            type="text"
            class="form-control campanha-form-control"
            formControlName="nome"
            autocomplete="off"
            maxlength="50"
            data-testid="campanha-form-nome"
            [class.is-invalid]="showControlError('nome')"
            aria-required="true"
            [attr.aria-invalid]="showControlError('nome')"
            [attr.aria-describedby]="showControlError('nome') ? 'campanha-form-nome-error' : null"
          />
          @if (showControlError('nome')) {
            <span
              id="campanha-form-nome-error"
              class="campanha-form-error"
              role="alert"
              data-testid="campanha-form-nome-error"
            >
              @if (form.controls['nome'].hasError('maxlength')) {
                O nome da campanha deve ter no máximo 50 caracteres.
              } @else {
                Informe o nome da campanha.
              }
            </span>
          }
        </div>

        <div class="col-12 col-lg-6">
          <label class="campanha-form-label" for="campanha-form-nome-exibicao">
            Nome de exibição (opcional)
            <span
              class="tooltip-container tooltip-top"
              data-tooltip="Nome que irá ficar visível no portal do participante"
              data-testid="campanha-form-nome-exibicao-tooltip"
              tabindex="0"
              aria-label="Nome que irá ficar visível no portal do participante"
            >ⓘ</span>
          </label>
          <input
            id="campanha-form-nome-exibicao"
            type="text"
            class="form-control campanha-form-control"
            formControlName="nomeExibicao"
            autocomplete="off"
            data-testid="campanha-form-nome-exibicao"
          />
        </div>

        <div class="col-12">
          <label class="campanha-form-label" for="campanha-form-descricao">
            Descreva aqui o objetivo da sua campanha
            <span class="campanha-form-required" aria-hidden="true">*</span>
          </label>
          <textarea
            id="campanha-form-descricao"
            class="form-control campanha-form-control campanha-form-textarea"
            formControlName="descricao"
            rows="4"
            maxlength="800"
            data-testid="campanha-form-descricao"
            [class.is-invalid]="showControlError('descricao')"
            aria-required="true"
            [attr.aria-invalid]="showControlError('descricao')"
            [attr.aria-describedby]="
              showControlError('descricao') ? 'campanha-form-descricao-error' : null
            "
          ></textarea>
          @if (showControlError('descricao')) {
            <span
              id="campanha-form-descricao-error"
              class="campanha-form-error"
              role="alert"
              data-testid="campanha-form-descricao-error"
            >
              @if (form.controls['descricao'].hasError('maxlength')) {
                A descrição deve ter no máximo 800 caracteres.
              } @else {
                Informe o objetivo da campanha.
              }
            </span>
          }
        </div>

        <div class="col-12">
          <label class="campanha-form-label" for="campanha-form-instrucoes">
            Instruções da campanha
            <span class="campanha-form-required" aria-hidden="true">*</span>
            <span
              class="tooltip-container tooltip-top"
              data-tooltip="Aqui você deve descrever como vai funcionar a sua campanha, incluindo informações de fluxo, entendimento e contexto"
              data-testid="campanha-form-instrucoes-tooltip"
              tabindex="0"
              aria-label="Aqui você deve descrever como vai funcionar a sua campanha, incluindo informações de fluxo, entendimento e contexto"
            >ⓘ</span>
          </label>
          <textarea
            id="campanha-form-instrucoes"
            class="form-control campanha-form-control campanha-form-textarea"
            formControlName="instrucoes"
            rows="4"
            data-testid="campanha-form-instrucoes"
            [class.is-invalid]="showControlError('instrucoes')"
            aria-required="true"
            [attr.aria-invalid]="showControlError('instrucoes')"
            [attr.aria-describedby]="
              showControlError('instrucoes') ? 'campanha-form-instrucoes-error' : null
            "
          ></textarea>
          @if (showControlError('instrucoes')) {
            <span
              id="campanha-form-instrucoes-error"
              class="campanha-form-error"
              role="alert"
              data-testid="campanha-form-instrucoes-error"
            >
              Informe as instruções da campanha.
            </span>
          }
        </div>
      </div>
    </section>

    <section
      class="campanha-form-section"
      aria-labelledby="campanha-form-section-2-title"
      data-testid="campanha-form-section-2"
    >
      <h2 id="campanha-form-section-2-title" class="campanha-form-section-title">
        2. Vigência da campanha
      </h2>

      <div class="campanha-form-fields campanha-form-vigencia-fields row g-3">
        <div class="col-12 col-md-6 col-lg-3">
          <label class="campanha-form-label" for="campanha-form-data-inicio">
            Data início
            <span class="campanha-form-required" aria-hidden="true">*</span>
          </label>
          <input
            id="campanha-form-data-inicio"
            type="date"
            class="form-control campanha-form-control"
            formControlName="dataInicio"
            data-testid="campanha-form-data-inicio"
            [attr.min]="hoje"
            [class.is-invalid]="showControlError('dataInicio') || showDataInicioNoPassadoError()"
            aria-required="true"
            [attr.aria-invalid]="showControlError('dataInicio') || showDataInicioNoPassadoError()"
            [attr.aria-describedby]="
              showControlError('dataInicio')
                ? 'campanha-form-data-inicio-error'
                : showDataInicioNoPassadoError()
                  ? 'campanha-form-data-inicio-passado-error'
                  : null
            "
          />
          @if (showControlError('dataInicio')) {
            <span
              id="campanha-form-data-inicio-error"
              class="campanha-form-error"
              role="alert"
              data-testid="campanha-form-data-inicio-error"
            >
              Informe a data de início.
            </span>
          }
          @if (showDataInicioNoPassadoError()) {
            <span
              id="campanha-form-data-inicio-passado-error"
              class="campanha-form-error"
              role="alert"
              data-testid="campanha-form-data-inicio-passado-error"
            >
              A data e o horário de início devem ser posteriores ao momento atual.
            </span>
          }
        </div>

        <div class="col-12 col-md-6 col-lg-3">
          <label class="campanha-form-label" for="campanha-form-horario-inicio">
            Horário inicial
            <span class="campanha-form-required" aria-hidden="true">*</span>
          </label>
          <input
            id="campanha-form-horario-inicio"
            type="time"
            class="form-control campanha-form-control"
            formControlName="horarioInicio"
            data-testid="campanha-form-horario-inicio"
            [class.is-invalid]="
              showControlError('horarioInicio') || showDataInicioNoPassadoError()
            "
            aria-required="true"
            [attr.aria-invalid]="
              showControlError('horarioInicio') || showDataInicioNoPassadoError()
            "
            [attr.aria-describedby]="
              showControlError('horarioInicio') ? 'campanha-form-horario-inicio-error' : null
            "
          />
          @if (showControlError('horarioInicio')) {
            <span
              id="campanha-form-horario-inicio-error"
              class="campanha-form-error"
              role="alert"
              data-testid="campanha-form-horario-inicio-error"
            >
              Informe o horário inicial.
            </span>
          }
        </div>

        <div class="col-12 col-md-6 col-lg-3">
          <label class="campanha-form-label" for="campanha-form-data-fim">
            Data fim
            <span class="campanha-form-required" aria-hidden="true">*</span>
          </label>
          <input
            id="campanha-form-data-fim"
            type="date"
            class="form-control campanha-form-control"
            formControlName="dataFim"
            data-testid="campanha-form-data-fim"
            [attr.min]="hoje"
            [class.is-invalid]="
              showControlError('dataFim') ||
              showDataFimBeforeDataInicioError() ||
              showDataFimNoPassadoError()
            "
            aria-required="true"
            [attr.aria-invalid]="
              showControlError('dataFim') ||
              showDataFimBeforeDataInicioError() ||
              showDataFimNoPassadoError()
            "
            [attr.aria-describedby]="
              showControlError('dataFim')
                ? 'campanha-form-data-fim-error'
                : showDataFimBeforeDataInicioError()
                  ? 'campanha-form-data-fim-vigencia-error'
                  : showDataFimNoPassadoError()
                    ? 'campanha-form-data-fim-passado-error'
                    : null
            "
          />
          @if (showControlError('dataFim')) {
            <span
              id="campanha-form-data-fim-error"
              class="campanha-form-error"
              role="alert"
              data-testid="campanha-form-data-fim-error"
            >
              Informe a data fim.
            </span>
          }
          @if (showDataFimBeforeDataInicioError()) {
            <span
              id="campanha-form-data-fim-vigencia-error"
              class="campanha-form-error"
              role="alert"
              data-testid="campanha-form-data-fim-vigencia-error"
            >
              O fim da vigência deve ser posterior ao início.
            </span>
          }
          @if (showDataFimNoPassadoError()) {
            <span
              id="campanha-form-data-fim-passado-error"
              class="campanha-form-error"
              role="alert"
              data-testid="campanha-form-data-fim-passado-error"
            >
              A data e o horário de fim não podem ser anteriores ao momento atual.
            </span>
          }
        </div>

        <div class="col-12 col-md-6 col-lg-3">
          <label class="campanha-form-label" for="campanha-form-horario-fim">
            Horário final
            <span class="campanha-form-required" aria-hidden="true">*</span>
          </label>
          <input
            id="campanha-form-horario-fim"
            type="time"
            class="form-control campanha-form-control"
            formControlName="horarioFim"
            data-testid="campanha-form-horario-fim"
            [class.is-invalid]="
              showControlError('horarioFim') ||
              showDataFimNoPassadoError() ||
              showDataFimBeforeDataInicioError()
            "
            aria-required="true"
            [attr.aria-invalid]="
              showControlError('horarioFim') ||
              showDataFimNoPassadoError() ||
              showDataFimBeforeDataInicioError()
            "
            [attr.aria-describedby]="
              showControlError('horarioFim') ? 'campanha-form-horario-fim-error' : null
            "
          />
          @if (showControlError('horarioFim')) {
            <span
              id="campanha-form-horario-fim-error"
              class="campanha-form-error"
              role="alert"
              data-testid="campanha-form-horario-fim-error"
            >
              Informe o horário final.
            </span>
          }
        </div>
      </div>

      <section
        class="campanha-form-subsection"
        aria-labelledby="campanha-form-section-2-1-title"
        data-testid="campanha-form-section-2-1"
      >
        <h3 id="campanha-form-section-2-1-title" class="campanha-form-subsection-title">
          2.1 Início da Vigência de alteração no portal para o participante
        </h3>

        <div class="campanha-form-fields campanha-form-vigencia-fields row g-3">
          <!-- <div class="col-12 col-md-4">
            <label class="campanha-form-label" for="campanha-form-data-hora-integracao">
              Data/Hora da Integração
            </label>
            <input
              id="campanha-form-data-hora-integracao"
              type="text"
              class="form-control campanha-form-control"
              disabled
              data-testid="campanha-form-data-hora-integracao"
              [value]="dataHoraIntegracaoLabel()"
            />
          </div> -->
          <div class="col-12 col-md-4">
            <label class="campanha-form-label" for="campanha-form-data-inicio-previsto">
              Data Início Previsto
              @if (!somenteLeitura()) {
                <span class="campanha-form-required" aria-hidden="true">*</span>
              }
            </label>
            @if (somenteLeitura()) {
              <!-- Modo visualizar: exibe a data formatada de `dtIniVigPartic`. -->
              <input
                id="campanha-form-data-inicio-previsto"
                type="text"
                class="form-control campanha-form-control"
                disabled
                data-testid="campanha-form-data-inicio-previsto"
                [value]="dataInicioPrevistoLabel()"
              />
            } @else {
              <input
                id="campanha-form-data-inicio-previsto"
                type="date"
                class="form-control campanha-form-control"
                formControlName="participanteDataInicio"
                data-testid="campanha-form-data-inicio-previsto"
                [class.is-invalid]="showControlError('participanteDataInicio')"
                aria-required="true"
                [attr.aria-invalid]="showControlError('participanteDataInicio')"
                [attr.aria-describedby]="
                  showControlError('participanteDataInicio')
                    ? 'campanha-form-data-inicio-previsto-error'
                    : null
                "
              />
              @if (showControlError('participanteDataInicio')) {
                <span
                  id="campanha-form-data-inicio-previsto-error"
                  class="campanha-form-error"
                  role="alert"
                  data-testid="campanha-form-data-inicio-previsto-error"
                >
                  Informe a data de início prevista.
                </span>
              }
            }
          </div>
        </div>
      </section>
    </section>

    <section
      class="campanha-form-section"
      aria-labelledby="campanha-form-section-3-title"
      data-testid="campanha-form-section-3"
    >
      <h2 id="campanha-form-section-3-title" class="campanha-form-section-title">
        3. Regras
      </h2>

      <div class="campanha-form-fields campanha-form-regras-fields">
        <div class="campanha-form-planos-block">
          <label class="campanha-form-label" for="campanha-form-plano-busca">
            Planos elegíveis
          </label>

          @if (!somenteLeitura() && !selecionarTodosPlanos()) {
            <input
              id="campanha-form-plano-busca"
              type="search"
              class="form-control campanha-form-control"
              placeholder="Buscar plano por nome ou código"
              autocomplete="off"
              data-testid="campanha-form-plano-busca"
              [value]="planoSearchTerm()"
              (input)="onPlanoSearchInput($event)"
            />

            @if (planoSearchTerm().trim() && filteredPlanos().length > 0) {
              <ul
                class="campanha-form-planos-suggestions"
                role="listbox"
                aria-label="Resultados da busca de planos"
                data-testid="campanha-form-planos-suggestions"
              >
                @for (plano of filteredPlanos(); track plano.id) {
                  <li role="option">
                    <button
                      type="button"
                      class="campanha-form-planos-suggestion-btn"
                      [attr.data-testid]="'campanha-form-adicionar-plano-' + plano.id"
                      (click)="addPlano(plano)"
                    >
                      <span class="campanha-form-planos-suggestion-nome">{{ plano.nome }}</span>
                      <span class="campanha-form-planos-suggestion-codigo">{{ plano.codigo }}</span>
                    </button>
                  </li>
                }
              </ul>
            } @else if (planoSearchTerm().trim() && filteredPlanos().length === 0) {
              <p class="campanha-form-planos-hint" data-testid="campanha-form-planos-sem-resultado">
                Nenhum plano encontrado para esta busca.
              </p>
            }
          } @else if (selecionarTodosPlanos()) {
            <!-- Só quando a opção está marcada: no modo visualizar a busca some de qualquer
                 jeito, e a frase apareceria mesmo numa campanha com planos escolhidos a dedo. -->
            <p class="campanha-form-planos-hint" data-testid="campanha-form-planos-todos-selecionados">
              Todos os planos do catálogo estão elegíveis para esta campanha.
            </p>
          }

          <div class="campanha-form-planos-actions row g-3 align-items-center">
            <div class="col-12 col-md-auto">
              <div class="form-check campanha-form-planos-check">
                <input
                  id="campanha-form-selecionar-todos-planos"
                  type="checkbox"
                  class="form-check-input"
                  formControlName="selecionarTodosPlanos"
                  data-testid="campanha-form-selecionar-todos-planos"
                  (change)="onSelecionarTodosPlanos($event)"
                />
                <label class="form-check-label" for="campanha-form-selecionar-todos-planos">
                  Selecionar todos os planos
                </label>
              </div>
            </div>
          </div>

          <!-- Os planos vinculados aparecem mesmo com "todos" marcado: é a única forma de saber
               quais planos a campanha alcança. Só some numa campanha nova, onde "todos" está
               marcado e ainda não há vínculo nenhum para listar. -->
          @if (planosAdicionados().length > 0 || !selecionarTodosPlanos()) {
            <div
              class="campanha-form-planos-adicionados"
              data-testid="campanha-form-planos-adicionados"
            >
              <h3 class="campanha-form-planos-adicionados-title">Planos da campanha</h3>

              @if (planosAdicionados().length === 0) {
                <p class="campanha-form-planos-hint">
                  {{ somenteLeitura() ? 'Nenhum plano vinculado.' : 'Nenhum plano adicionado.' }}
                </p>
              } @else {
                <ul class="campanha-form-planos-list">
                  @for (plano of planosAdicionados(); track plano.id) {
                    <li class="campanha-form-planos-list-item">
                      <span class="campanha-form-planos-list-label">
                        {{ plano.nome }}
                        <span class="campanha-form-planos-list-codigo">({{ plano.codigo }})</span>
                      </span>
                      @if (!somenteLeitura()) {
                        <button
                          type="button"
                          class="campanha-form-planos-remove-btn"
                          [attr.aria-label]="'Remover ' + plano.nome"
                          [attr.data-testid]="'campanha-form-remover-plano-' + plano.id"
                          (click)="removePlano(plano.id)"
                        >
                          ×
                        </button>
                      }
                    </li>
                  }
                </ul>
              }

              @if (showPlanosRequiredError()) {
                <span
                  class="campanha-form-error"
                  role="alert"
                  data-testid="campanha-form-planos-error"
                >
                  Adicione ao menos um plano ou marque &quot;Selecionar todos os planos&quot;.
                </span>
              }
            </div>
          }
        </div>

        <div
          class="campanha-form-regras-toggles"
          role="group"
          aria-label="Regras da campanha"
        >
          <!-- Removidos por solicitação do PO — manter comentados.
          <app-form-toggle
            formControlName="permitirReopcao"
            label="Permitir reopção"
            testId="campanha-form-permitir-reopcao"
          />
          <app-form-toggle
            formControlName="limitePorCpf"
            label="Limite por CPF"
            testId="campanha-form-limite-por-cpf"
          />
          <app-form-toggle
            formControlName="importacaoObrigatoria"
            label="Importacao de participantes obrigatoria para ativar a campanha"
            testId="campanha-form-importacao-obrigatoria"
          />
          -->
        </div>
      </div>
    </section>

    <section
      class="campanha-form-section"
      aria-labelledby="campanha-form-section-4-title"
      data-testid="campanha-form-section-4"
    >
      <h2 id="campanha-form-section-4-title" class="campanha-form-section-title">
        4. Importa Lista de participantes Elegíveis
      </h2>

      <div class="campanha-form-fields campanha-form-importar-base-fields row g-3 align-items-center">
        <div class="col-12 col-md-auto">
          <button
            type="button"
            class="btn btn-outline-primary campanha-form-importar-base-btn"
            data-testid="campanha-form-importar-base"
            [disabled]="somenteLeitura() || importando() || !isEditMode()"
            (click)="fileInputBase.click()"
          >
            {{ importando() ? 'Importando...' : 'Importar base' }}
          </button>
        </div>

        @if (baseImportada()) {
          <div class="col-12 col-md-auto">
            <span
              class="campanha-form-base-importada"
              data-testid="campanha-form-base-importada"
              role="status"
            >
              <span class="campanha-form-base-importada-icon" aria-hidden="true">&#10003;</span>
              Base importada
            </span>
          </div>
        }

        @if (!isEditMode()) {
          <div class="col-12">
            <p class="campanha-form-planos-hint" data-testid="campanha-form-importar-base-hint">
              Salve o rascunho para importar a base
            </p>
          </div>
        }

        <input
          #fileInputBase
          type="file"
          accept=".xlsx,.xls,.csv"
          class="visually-hidden"
          data-testid="campanha-form-importar-base-input"
          [disabled]="somenteLeitura()"
          (change)="onArquivoBaseSelecionado($event)"
        />
      </div>
    </section>

    <section
      class="campanha-form-section"
      aria-labelledby="campanha-form-section-5-title"
      data-testid="campanha-form-section-5"
    >
      <h2 id="campanha-form-section-5-title" class="campanha-form-section-title">
        5. Selecione o Tipo de Campanha
      </h2>

      <div class="campanha-form-fields campanha-form-destino-fields row g-3">
        <div class="col-12 col-lg-6">
          <label class="campanha-form-label" for="campanha-form-tipo-destino">
            Selecione o tipo de Campanha
            <span class="campanha-form-required" aria-hidden="true">*</span>
          </label>
          <select
            id="campanha-form-tipo-destino"
            class="form-select campanha-form-control"
            formControlName="tipoDestino"
            data-testid="campanha-form-tipo-destino"
            [class.is-invalid]="showTipoDestinoRequiredError()"
            aria-required="true"
            [attr.aria-invalid]="showTipoDestinoRequiredError()"
            [attr.aria-describedby]="
              showTipoDestinoRequiredError() ? 'campanha-form-tipo-destino-error' : null
            "
          >
            <option value="" disabled hidden>Selecione o tipo de Campanha</option>
            <option [value]="TipoDestinoCampanha.Suitability">Suitability</option>
          </select>
          @if (showTipoDestinoRequiredError()) {
            <span
              id="campanha-form-tipo-destino-error"
              class="campanha-form-error"
              role="alert"
              data-testid="campanha-form-tipo-destino-error"
            >
              Selecione o tipo de campanha.
            </span>
          }
        </div>

        <div class="col-12 col-lg-6">
          <label class="campanha-form-label" for="campanha-form-destino-id">
            Tipo de Questionário
            <span class="campanha-form-required" aria-hidden="true">*</span>
          </label>
          <select
            id="campanha-form-destino-id"
            class="form-select campanha-form-control"
            formControlName="destinoId"
            data-testid="campanha-form-destino-id"
            [class.is-invalid]="showDestinoRequiredError()"
            aria-required="true"
            [attr.aria-invalid]="showDestinoRequiredError()"
            [attr.aria-describedby]="
              showDestinoRequiredError() ? 'campanha-form-destino-error' : null
            "
          >
            <option value="">
              @if (tipoDestino()) {
                Selecione o destino
              } @else {
                Selecione o tipo de destino primeiro
              }
            </option>
            @for (destino of destinosFiltrados(); track destino.id) {
              <option [value]="destino.id">{{ destino.nome }}</option>
            }
          </select>
          @if (showDestinoRequiredError()) {
            <span
              id="campanha-form-destino-error"
              class="campanha-form-error"
              role="alert"
              data-testid="campanha-form-destino-error"
            >
              Selecione o tipo de questionário.
            </span>
          }
        </div>

        @if (!somenteLeitura()) {
          <div class="col-12">
            <p class="campanha-form-planos-hint">
              Caso você não tenha criado a parametrização da sua campanha clique
              <a
                routerLink="/questionarios/novo"
                class="table-link"
                data-testid="campanha-form-criar-questionario"
              >Aqui</a>
            </p>
          </div>
        }
      </div>
    </section>

    <section
      class="campanha-form-section"
      aria-labelledby="campanha-form-section-6-title"
      data-testid="campanha-form-section-6"
    >
      <h2 id="campanha-form-section-6-title" class="campanha-form-section-title">
        6. Perfil Padrão para esta Campanha
      </h2>

      <p
        class="campanha-form-planos-hint"
        [class.campanha-form-planos-hint--pendente]="semPerfilPadrao()"
        data-testid="campanha-form-perfil-padrao-hint"
      >
        Todos os participantes ainda sem perfil determinado, iniciam neste perfil padrão dentro
        desta campanha.
      </p>

      @if (!form.controls['destinoId'].value) {
        <p
          class="campanha-form-planos-hint"
          [class.campanha-form-planos-hint--pendente]="semPerfilPadrao()"
          data-testid="campanha-form-perfil-padrao-empty"
        >
          Selecione um tipo de questionário para ver os perfis disponíveis.
        </p>
      } @else if (perfisDoQuestionario().length === 0) {
        <p
          class="campanha-form-planos-hint"
          [class.campanha-form-planos-hint--pendente]="semPerfilPadrao()"
          data-testid="campanha-form-perfil-padrao-empty"
        >
          Este questionário ainda não possui perfis associados.
        </p>
      } @else {
        <div
          class="campanha-form-perfil-padrao-list"
          role="radiogroup"
          aria-label="Perfil padrão da campanha"
        >
          @for (perfil of perfisDoQuestionario(); track perfil.id) {
            <label
              class="campanha-form-perfil-padrao-row"
              data-testid="campanha-form-perfil-padrao-row"
            >
              <span class="campanha-form-perfil-padrao-info">
                <span class="campanha-form-perfil-padrao-id">#{{ perfil.id }}</span>
                <span class="campanha-form-perfil-padrao-nome">{{
                  perfil.nomeExibicao || perfil.nome
                }}</span>
              </span>
              @if (form.controls['idPerfilInvestimentoDef'].value === perfil.id) {
                <app-status-badge [status]="perfil.status" />
              }
              <input
                type="radio"
                formControlName="idPerfilInvestimentoDef"
                [value]="perfil.id"
                data-testid="campanha-form-perfil-padrao-radio"
              />
            </label>
          }
        </div>
        @if (showPerfilPadraoRequiredError()) {
          <span
            class="campanha-form-error"
            role="alert"
            data-testid="campanha-form-perfil-padrao-error"
          >
            Selecione um perfil padrão para a campanha.
          </span>
        }
      }
    </section>

    <section
      class="campanha-form-section"
      aria-labelledby="campanha-form-section-7-title"
      data-testid="campanha-form-section-7"
    >
      <h2 id="campanha-form-section-7-title" class="campanha-form-section-title">
        7. Adicionar Termo de Ciência
      </h2>

      <div class="campanha-form-fields campanha-form-termo-fields row g-3">
        <div class="col-12">
          <app-form-toggle
            formControlName="exibeTermo"
            label="Exibe termo"
            testId="campanha-form-exibe-termo"
          />
        </div>

        <div class="col-12 col-lg-6">
          <label class="campanha-form-label" for="campanha-form-tipo-termo">
            Selecione o tipo de Termo
          </label>
          <select
            id="campanha-form-tipo-termo"
            class="form-select campanha-form-control"
            formControlName="tipoTermo"
            data-testid="campanha-form-tipo-termo"
          >
            <option value="">Selecione o tipo de termo</option>
            <option value="perfil-investimento">Termo - Perfil Investimento</option>
          </select>
        </div>
      </div>
    </section>

    <!-- Removida por solicitação do PO — manter comentada.
    <section
      class="campanha-form-section"
      aria-labelledby="campanha-form-section-8-title"
      data-testid="campanha-form-section-8"
    >
      <h2 id="campanha-form-section-8-title" class="campanha-form-section-title">
        8. Publicação
      </h2>

      <div class="campanha-form-fields campanha-form-publicacao-fields row g-3">
        <div class="col-12 col-lg-8">
          <label class="campanha-form-label" for="campanha-form-link-campanha">
            Link da campanha
          </label>
          <input
            id="campanha-form-link-campanha"
            type="text"
            class="form-control campanha-form-control campanha-form-link-input"
            formControlName="linkCampanha"
            readonly
            tabindex="-1"
            aria-readonly="true"
            placeholder="O link será gerado ao publicar a campanha"
            data-testid="campanha-form-link-campanha"
          />
        </div>

        <div class="col-12 col-lg-4 campanha-form-copiar-col">
          <button
            type="button"
            class="btn btn-outline-primary campanha-form-copiar-link-btn"
            data-testid="campanha-form-copiar-link"
            (click)="onCopiarLink()"
          >
            Copiar
          </button>
        </div>
      </div>
    </section>
    -->

    @if (!somenteLeitura()) {
      <footer
        class="campanha-form-footer"
        role="toolbar"
        aria-label="Ações do formulário"
        data-testid="campanha-form-footer"
      >
        <div class="campanha-form-footer-actions">
          <button
            type="button"
            class="btn btn-outline-primary campanha-form-footer-btn"
            data-testid="campanha-form-salvar-rascunho"
            [disabled]="isSaving()"
            (click)="onSalvarRascunho()"
          >
            {{ isSaving() ? 'Salvando...' : 'Salvar como rascunho' }}
          </button>
          <button
            type="button"
            class="btn btn-primary campanha-form-footer-btn"
            data-testid="campanha-form-publicar"
            [disabled]="isSaving()"
            (click)="onAgendar()"
          >
            {{ isSaving() ? 'Agendando...' : 'Agendar Campanha' }}
          </button>
        </div>
        @if (podeExcluir()) {
          <button
            type="button"
            class="campanha-form-excluir-link"
            data-testid="campanha-form-excluir"
            [disabled]="isSaving()"
            (click)="onExcluir()"
          >
            Excluir campanha
          </button>
        }
      </footer>
    }
  </form>

  @if (!somenteLeitura() && showDeleteDialog()) {
    <app-alert-dialog
      title="Excluir campanha"
      message="Tem certeza que deseja excluir esta campanha?"
      description="Essa ação removerá permanentemente a campanha selecionada."
      cancelLabel="Cancelar"
      confirmLabel="Excluir"
      [showConfirmIcon]="false"
      (confirm)="confirmarExclusao()"
      (cancel)="cancelarExclusao()"
    />
  }

  @if (!somenteLeitura() && showConfirmarAgendamento()) {
    <app-alert-dialog
      title="Confirmar publicação"
      message="Solicitamos que revise os dados informados e confirme se todas as informações estão corretas e atualizadas. Caso estejam corretas, clique em Publicar para concluir."
      [description]="avisoCampanhaAtivaExistente()"
      cancelLabel="Cancelar"
      confirmLabel="Publicar"
      [showConfirmIcon]="false"
      (confirm)="confirmarAgendamento()"
      (cancel)="cancelarAgendamento()"
    />
  }
</div>
